<!--
 * @Author: FengXiao
 * @Date: 2020-07-14 15:10:28
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 00:48:24
-->
<template>
  <div class="speech-detail-page page-container">
    <video-player
      :datas="videoData"
      :speaker="speaker"
      :allowEvent.sync="playerAllowEvent"
      :collect="miniTabActive[HEART_ID]"
      @clickCollect="onClickMiniTab(HEART_ID)"
    ></video-player>
	
	
    <div class="content">
      <div class="left-bl clearfix">
        <transition name="el-fade-in-linear">
          <div class="child-bl" v-html="draft" v-show="miniTabActive[DOC_ID]"></div>
        </transition>
        <transition name="el-fade-in-linear">
          <comment-list
            class="child-bl"
            :topic="topic"
            type="speech"
            :id="speechId"
            v-show="!miniTabActive[DOC_ID]"
            @inputFocus="inputFocus"
          ></comment-list>
        </transition>
      </div>
      <div class="right-bl">
        <mini-tabs @onClickTab="onClickMiniTab" :active="miniTabActive"></mini-tabs>
        <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import CommentList from '@/components/AppCommentList';
import 'element-ui/lib/theme-chalk/base.css';
import RecommendVideos from '@/components/AppRecommendVideos';
import MiniTabs from '@/components/AppMiniTabs';
import requestApi from '@/service';

import configFields from '@/utils/configFields';
const { DOC_ID, HEART_ID, DRAFT_TYPE } = configFields;
export default {
  name: 'SpeechDetail',
  components: {
    VideoPlayer,
    CommentList,
    RecommendVideos,
    MiniTabs,
  },
  data() {
    return {
      videoData: {},
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      speaker: {},
      showHeart: false,
      showDoc: false,
      recommendList: [],
      topic: {},
      draft: '',
      DOC_ID,
      HEART_ID,
      miniTabActive: {},
      speechId: '',
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/speech/detail') {
        this.init();
      }
    },
  },
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
      this.speechId = +this.$route.query.id;
      this.miniTabActive = {
        [DOC_ID]: false,
        [HEART_ID]: false,
      };
      this.getDetail();
      this.getRecommend();
      this.initScrollTop();
    },
    getDetail() {
      const url = `/api/site/speech/${this.speechId}/detail/`;
      requestApi(url).then(({ speech }) => {
		  // console.log(speech)
        const { speaker, video_url, cover, titlelanguage, title, first_category, date, city, audio_duration, audio_url, is_collect } = speech;
       // console.log(video_url)
		this.speaker = speaker;
        this.videoData = {
          cover,
          videoUrls: video_url,
          intro: titlelanguage,
        };
		// console.log(this.videoData)
        this.topic = {
          title,
          category: first_category,
          date,
          city,
          intro: titlelanguage,
        };
        this.audioData = {
          duration: audio_duration,
          url: audio_url,
        };
        this.miniTabActive[HEART_ID] = is_collect;
      });
    },
    getRecommend() {
      const url = `/api/site/speech/${this.speechId}/recommend/`;
      requestApi(url).then(({ recommended }) => {
        if (recommended && recommended.length) {
          this.recommendList = recommended.map(item => {
            item.category = item.first_category;
            return item;
          });
        } else {
          this.recommendList = [];
        }
      });
    },
    /**
     * @description: 获取演讲稿
     */
    getDarft() {
      return new Promise(resolve => {
        requestApi('/api/site/draft/', {
          id: this.speechId,
          type: DRAFT_TYPE.speech,
        }).then(({ draft }) => {
          if (draft) {
            this.draft = draft;
            resolve(true);
          } else {
            this.$message.error('未找到文稿');
            resolve(false);
          }
        });
      });
    },
    /**
     * @description: 显示文稿
     * @param {type}
     * @return:
     */
    showDocFn(val) {
      this.showDoc = val;
    },
    /**
     * @description: 显示收藏
     * @param {type}
     * @return:
     */
    showHeartFn(val) {
      if (!this.$store.state.token) {
        this.$router.push('/userCenter');
        return;
      }
      this.showHeart = val;
    },
    onClickRecommend(id) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id,
        },
      });
    },
    onClickMiniTab(id) {
      if (id === DOC_ID) {
        if (!this.draft) {
          this.getDarft().then(res => {
            if (res) {
              this.miniTabActive[id] = !this.miniTabActive[id];
            }
          });
        } else {
          this.miniTabActive[id] = !this.miniTabActive[id];
        }
      } else if (id === HEART_ID) {
        if (this.checkLogin()) {
          this.collect().then(() => {
            this.miniTabActive[id] = !this.miniTabActive[id];
          });
        }
      }
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
    /**
     * @description: 收藏
     */
    collect() {
      return requestApi(
        '/api/v1/speech/collection/change/',
        {
          speech_id: this.speechId,
        },
        'POST'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.speech-detail-page {
  .content {
    display: flex;
    align-items: flex-start;
    margin: 20px auto 100px;
    .left-bl {
      width: 72%;
      max-width: 827px;
      margin-right: 10px;
      box-sizing: border-box;
      background: $C1;
      padding: 0 40px;
      position: relative;
      .child-bl {
        float: left;
        left: 0;
        top: 0;
        width: 100%;
      }
    }
    .right-bl {
      width: 28%;
      background-color: $C10;
    }
  }
}
</style>
